import {
  getVariantFromSelectedOptions,
  getOptionsAccessibility,
} from './scripts/options';

export default class OptionsSelector extends Core.Component {
  constructor(el, context) {
    super(el, context);

    this.el.style.display = '';
    this._onChangeFn = this._onOptionChange.bind(this);

    this._optionsEls = this.el.querySelectorAll('[data-variant-option]');
  }

  onMount() {
    if (!this.context.product) return;

    const selectedOptions = this.getSelectedOptions();

    this._setOptionVisibility(selectedOptions);
    this._updateOptionAvailability(selectedOptions);

    this.events.register(this.el, 'change', this._onChangeFn);
  }

  getSelectedOptions() {
    const options = [...this.queryAll('option-dropdown'), ...this.queryAll('option-selectable-boxes')];
    const selectedOptions = options.reduce((acc, option) => {
      const { selectedValue } = option;

      if (selectedValue) {
        acc[option.position - 1] = selectedValue;
      }

      return acc;
    }, options.map(() => ''));

    return selectedOptions;
  }

  setSelectedOptions(selectedOptions) {
    const options = [...this.queryAll('option-dropdown'), ...this.queryAll('option-selectable-boxes')];

    options.forEach(option => {
      if (option.position - 1 < selectedOptions.length) {
        option.selectedValue = selectedOptions[option.position - 1];
      }
    });

    this._onOptionChange();
  }

  _setOptionVisibility(selectedOptions) {
    const optionsAccessibility = getOptionsAccessibility(this.context.product, selectedOptions);
    const options = [...this.queryAll('option-dropdown'), ...this.queryAll('option-selectable-boxes')];

    options.forEach(option => {
      const optionValueAccessibility = optionsAccessibility[option.position - 1];

      const inaccessibleValues = Object
        .keys(optionValueAccessibility)
        .filter(value => !optionValueAccessibility[value].accessible);

      if (this.data.remove_unavailable) {
        option.removeValues(inaccessibleValues);
      } else if (this.data.disable_unavailable) {
        option.disableValues(inaccessibleValues);
      }
    });
  }

  _updateOptionAvailability(selectedOptions) {
    const optionsAccessibility = getOptionsAccessibility(this.context.product, selectedOptions);
    const options = [...this.queryAll('option-dropdown'), ...this.queryAll('option-selectable-boxes')];

    options.forEach(option => {
      const optionValueAvailability = optionsAccessibility[option.position - 1];

      const unavailableValues = Object
        .keys(optionValueAvailability)
        .filter(value => !optionValueAvailability[value].available);

      option.setUnavailableValues(unavailableValues);
    });
  }

  _updateVariantSelection(selectedOptions) {
    if (!this.context.product) return;

    const variant = getVariantFromSelectedOptions(
      this.context.product.variants,
      selectedOptions,
    );

    let state = 'selected';

    if (!variant) {
      const isUnselected = selectedOptions.some(option => option === '');

      state = isUnselected ? 'unselected' : 'unavailable';
    }

    const event = new CustomEvent('product:options-change', {
      bubbles: true,
      cancelable: false,
      detail: {
        variant,
        options: selectedOptions,
        state,
      },
    });

    this.el.dispatchEvent(event);
  }

  _onOptionChange() {
    const selectedOptions = this.getSelectedOptions();

    this._updateOptionAvailability(selectedOptions);
    this._updateVariantSelection(selectedOptions);
  }
}
